import { render, staticRenderFns } from "./SidebarContactDocumentsBlock.vue?vue&type=template&id=25a9c21e&scoped=true"
import script from "./SidebarContactDocumentsBlock.vue?vue&type=script&lang=ts"
export * from "./SidebarContactDocumentsBlock.vue?vue&type=script&lang=ts"
import style0 from "./SidebarContactDocumentsBlock.vue?vue&type=style&index=0&id=25a9c21e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25a9c21e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('25a9c21e')) {
      api.createRecord('25a9c21e', component.options)
    } else {
      api.reload('25a9c21e', component.options)
    }
    module.hot.accept("./SidebarContactDocumentsBlock.vue?vue&type=template&id=25a9c21e&scoped=true", function () {
      api.rerender('25a9c21e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/browse/sidebar/SidebarContactDocumentsBlock.vue"
export default component.exports